import React from 'react';
import { renderIf } from 'modules/render-if';
import { Actions } from '../reducer';

export default ({ model, dispatch }) => {
  return (
    <a className="cart-btn"
      rel="nofollow"
      onClick={() => dispatch(Actions.toggle())}
    >
      {renderIf(model.lineItems.length)(() => (
        <span className="badge">{model.lineItems.length}</span>
      ))}
    </a>
  );
};



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/components/CartButton.js
 **/